import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ISchool } from 'src/shared/interfaces/groups/school.interface';
import { AuthState } from 'src/shared/store/state/auth.state';
import { SetCurrentSchoolYear } from './../actions/school-year.action';

import { ISchoolYear } from '../../interfaces/groups/school-year.interface';
import { IQuestionChoices } from '../../interfaces/radio-checkbox-config.interface';
import { SchoolYearsService } from '../../services/school-years.service';
import { GetAllSchoolYear } from '../actions/school-year.action';

export interface SchoolYearStateModel {
    schoolYears: ISchoolYear[];
    currentSchoolYear: ISchoolYear;
}

@State<SchoolYearStateModel>({
    name: 'schoolYear',
    defaults: {
        schoolYears: [],
        currentSchoolYear: null,
    },
})
@Injectable()
export class SchoolYearState {
    constructor(private schoolYearsService: SchoolYearsService, private store: Store) {}

    @Selector()
    public static getAllSchoolYear(state: SchoolYearStateModel): ISchoolYear[] {
        return state.schoolYears;
    }

    @Selector()
    public static getCurrentSchoolYear(state: SchoolYearStateModel): ISchoolYear {
        return state.currentSchoolYear;
    }

    @Selector()
    public static schoolYears(state: SchoolYearStateModel): IQuestionChoices[] {
        return state.schoolYears.map((schoolYear: ISchoolYear) => ({
            value: schoolYear.id,
            label: schoolYear.start_year + ' - ' + schoolYear.end_year,
        }));
    }

    @Selector()
    public static schoolYearsWithNone(state: SchoolYearStateModel): IQuestionChoices[] {
        return [{ label: 'REPERTOIRE.CONTACTS.FILTERS.SCHOOL-YEAR-ALL', value: 0 }].concat(
            state.schoolYears.map((schoolYear: ISchoolYear) => ({
                value: schoolYear.id,
                label: schoolYear.start_year + ' - ' + schoolYear.end_year,
            }))
        );
    }

    @Action(GetAllSchoolYear)
    public getAllSchoolYear(ctx: StateContext<SchoolYearStateModel>): Observable<ISchoolYear[]> | void {
        const selectedUser: number | null = this.store.selectSnapshot(AuthState.getStudentIdSelected);
        return this.schoolYearsService.getAllSchoolYears(selectedUser).pipe(
            tap((result: ISchoolYear[]) => {
                if (result) {
                    ctx.patchState({
                        schoolYears: result,
                    });
                }
                return null;
            })
        );
    }

    @Action(SetCurrentSchoolYear)
    public setCurrentSchoolYear(ctx: StateContext<SchoolYearStateModel>): Observable<ISchoolYear[]> | void {
        const schoolYears: ISchoolYear[] = ctx.getState().schoolYears;

        const currentSchool: ISchool = this.store.selectSnapshot(AuthState.currentSchool);
        if (schoolYears?.length) {
            ctx.patchState({
                currentSchoolYear: schoolYears.find((schoolYear: ISchoolYear) => currentSchool?.schoolYearId === schoolYear.id),
            });
        } else {
            return this.schoolYearsService.getAllSchoolYears().pipe(
                tap((result: ISchoolYear[]) => {
                    if (result) {
                        ctx.patchState({
                            schoolYears: result,
                            currentSchoolYear: result.find((schoolYear: ISchoolYear) => currentSchool?.schoolYearId === schoolYear.id),
                        });
                    }
                    return null;
                })
            );
        }
    }
}
